<template>
  <div>
    <div class="header-line" :class="{'white-header':(scrollTop>300||notHome)}">
      <div class="header d-sm-none d-xl-block" :class="{'white-header':(scrollTop>300||notHome)}">
        <b-container fluid>
          <b-row align-v="center">
            <b-col xl="3">
              <div class="header-left flex align-center justify-center hidden-sm">
                <img src="../assets/image/icon.png"  @click="goPage({url:'/'})"/>
                
              </div>
            </b-col>
            <b-col xl="8">
              <div class="header-middle flex justify-end hidden-sm">
                <div class="menu-list flex">
                  <div v-for="(item, index) in menuList" :key="index" class="menu-item" :class="{ 'active-item': current == item.name }" @click="goPage(item)">
                    {{ item.title }}
                  </div>
                </div>
              </div>
            </b-col>
            <b-col xl="1">
              <div class="header-right flex align-center hidden-sm">
                <div class="search-icon flex align-center justify-center">
                  <!-- <img src="../assets/image/icon19.png"/> -->
                  <i class="el-icon-search search-icon" @click="goSearch" v-if="showSearch"></i>
                </div>
                <!-- <div class="search-input">
                  <el-input v-model="keyword" placeholder="输入搜索关键字" />
                  <i class="el-icon-search search-icon"></i>
                </div> -->
              </div>
            </b-col>
          </b-row>
        </b-container>
      </div>
      <!-- h5 -->
      <div class="header sm-header d-sm-block d-xl-none">
        <b-container fluid>
          <b-row align-v="center">
            <b-col sm="9">
              <div class="sm-header-left flex align-center" @click="goPage({url:'/'})">
                <img src="../assets/image/icon.png" />
                <span>福州奇点星穹</span>
              </div>
            </b-col>
            <b-col sm="3">
              <div class="flex align-center justify-end">
                <div class="search-icon" @click="goSearch">
                  <img src="../assets/image/icon23.png"> 
              </div>
              <div class="sm-header-right flex justify-end" v-b-toggle="'collapse-menu'">
                <img src="../assets/image/icon2.png" class="when-opened" />
                <div class="when-closed flex align-center justify-center"><i class="el-icon-close"></i></div>
              </div>
              </div>
            </b-col>
            <b-collapse id="collapse-menu" class="collapse-menu">
              <div class="sm-menu">
                <div v-for="(item, index) in menuList" :key="index" class="sm-menu-item" :class="{ 'active-menu-item': index == chooseMenuIndex }" @click.stop="clickMenu(index, 0)">
                  <div class="sm-menu-item-line flex justify-between align-center" v-b-toggle="`collapse-menu-child-${index}`">
                    <div class="sm-menu-item-title">{{ item.title}}</div>
                    <div class="sm-menu-item-btn flex align-center justify-center" v-if="item.list">
                      <span class="btn-opened"><i class="el-icon-minus"></i></span>
                      <span class="btn-closed"><i class="el-icon-plus"></i></span>
                    </div>
                  </div>
                  <b-collapse :id="`collapse-menu-child-${index}`" v-if="item.list && item.list.length != 0" @click.stop="" accordion="collapse-once">
                    <div class="collapse-menu-child flex align-center" v-for="(child, cindex) in item.list" :key="cindex + 99" @click.stop="clickMenu(cindex, 1,index)" :class="{ 'active-menu-child-item': cindex == chooseMenuChildIndex }">
                      <div></div>
                      <span>{{ child.title }}</span>
                    </div>
                  </b-collapse>
                </div>
              </div>
            </b-collapse>
          </b-row>
        </b-container>
      </div>
    </div>
    <div class="pla-header" v-if="notHome"></div>
  </div>
</template>

<script>
import { getMenuList } from "@/api/index"
export default {
  props: {
    notHome: {
      type: Boolean,
      default: false
    },
    showSearch:{
      type:Boolean,
      default:true
    }
  },
  data() {
    return {
      keyword: '',
      menuList: [{
        title: '首页',
        name: 'home',
        url: '/'
      }, 
      {
        title: '新闻动态',
        list: [{
          title: '中心资讯'
        }, {
          title: '最新新闻'
        }, {
          title: '行业动态'
        }, {
          title: '通知公告'
        }],
        name: 'news',
        url: '/news'
      }, {
        title: '业务领域',
        name: 'bussiness',
        list: [{
          title: '产品与服务'
        }, {
          title: '技术与创新'
        }, {
          title: '行业动向'
        }],
        url: '/bussiness'
      }, {
        title: '联系我们',
        list: [{
          title: '留言'
        }, {
          title: '联系方式'
        }, {
          title: '交通指南'
        }],
        name: 'contactUs',
        url: '/contactUs'
      }, 
      {
        title: 'ERP介绍',
        name: 'recruit',
        url: 'https://www.qidianfj.com/chuhaiya/'
      }
    ],
      current: 'home',
      visible: false,
      chooseMenuIndex: -1,
      chooseMenuChildIndex: -1,
      scrollTop: 0
    }
  },
  created() {
    this.current = this.$route.name || 'home'
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    clickMenu(index, type,pindex) {
      if (type == 0) {
        this.chooseMenuIndex = index
        this.chooseMenuChildIndex = -1
        if (!this.menuList[this.chooseMenuIndex].list) {
          this.$router.push({ path: this.menuList[this.chooseMenuIndex].url })
        }
      } else {
        this.chooseMenuIndex = pindex
        if(this.menuList[this.chooseMenuIndex].name==this.$route.name){
          let detailFlag = false
          if (this.$route.path == '/newsDetail' || this.$route.path == '/newsList' || this.$route.path == '/recruitDetail') {
            detailFlag = true
          }
          if (!detailFlag) {
          // 当前页面
          this.$emit('goScroll',index)
          this.$root.$emit('bv::toggle::collapse', `collapse-menu-child-${pindex}`)
          this.$root.$emit('bv::toggle::collapse', 'collapse-menu')
          }else{
            this.$router.push({ path: this.menuList[this.chooseMenuIndex].url + '?to=' + index })
          }
        }else{
          this.chooseMenuChildIndex = index
          this.$router.push({ path: this.menuList[this.chooseMenuIndex].url + '?to=' + this.chooseMenuChildIndex })
        }
      }
    },
    handleScroll(e) {
      this.scrollTop = e.target.scrollTop || document.documentElement.scrollTop;
    },
    goPage(item) {
      let temp=item.url.substring(1)
      if(item.url.startsWith('http')){
        window.open(item.url)
        return
      }
      if(temp.indexOf('organizational')!=-1){
        temp='orga'
      }
      if(temp==''){
        temp='home'
      }
      let detailFlag=false
      if(this.$route.path=='/newsDetail'||this.$route.path=='/newsList'||this.$route.path=='/recruitDetail'){
        detailFlag=true
      }
      if(this.$route.name!=temp||detailFlag){
        this.$router.push({ path: item.url })
      }

    },
    changeCurrent(name) {
      console.log(this.changeCurrent)
      this.current = name
    },
    goSearch(){
      this.$router.push({path:'/search'})
    }
  }
}
</script>

<style scoped lang="scss">
.header-line {
  width: 100%;
  // background: #fff; // backdrop-filter: blur(10px);
  background: rgba(255, 255, 255, 0.2);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  backdrop-filter: blur(10px);
}

.header::before {
  width: 100%;
  height: 2px;
  position: absolute;
  bottom: 0;
  left: 0;
  background: #3b7af4;
  content: "";
}

.header {
  max-width: 1440px;
  position: relative;
  margin: 0 auto;

  &-left {
    padding: 20px 10px;
    user-select: none;



    .logo-name {
      font-family: "SourceHanSansCN-Bold";
      margin-left: 8px;

      div {
        font-weight: 500;
        font-size: 24px;
        color: #333333;
        line-height: 36px;
        text-align: left;
        font-style: normal;
      }
    }
  }

  &-middle {
    .menu-item {
      padding: 0 25px;
      height: 95px;
      line-height: 95px;
      user-select: none;
      cursor: pointer;
      font-family: "SourceHanSansCN-Regular";
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      position: relative;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .menu-item:hover {
      font-weight: bold;
      color: #3b7af4;
    }

    .active-item {
      font-weight: bold;
      color: #3b7af4;
    }

    .active-item::before {
      width: 100%;
      position: absolute;
      height: 4px;
      background: #3b7af4;
      content: "";
      left: 0;
      bottom: 0;
    }
  }

  &-right {
    .search-icon{
      width: 48px;
      height: 48px;
      img{
        width: 18px;
        height: 18px;
      }
      i{
        width: 18px;
        height: 18px;
        color: #fff;
        cursor: pointer;
      }
    }
    .search-input {
      width: 168px;
      height: 48px;
      position: relative;

      .search-icon {
        position: absolute;
        right: 20px;
        top: 15px;
        cursor: pointer;
      }
    }

    /deep/.el-input__inner {
      width: 168px;
      height: 48px;
      // background: #f0f0f0;
      background: rgba(240, 240, 240, 0.3);
      border: none;
    }

    /deep/.el-input__inner::placeholder {
      font-family: "SourceHanSansCN-Regular";
      font-weight: 500;
      font-size: 14px;
      color: #999;
    }
  }
}
.white-header {
  background: #fff;
  .search-icon{
    i{
      color: #333333;
    }
  }
}
// 小屏幕
.sm-header {
  background: #fff;
}

.sm-header-left {
  height: 95px;

  img {
    width: 73px;
    height: 50px;
    object-fit: contain;
  }

  span {
    font-family: "SourceHanSansCN-Regular";
    font-weight: 400;
    font-size: 36px;
    color: #000000;
    line-height: 54px;
    text-align: left;
    font-style: normal;
    margin-left: 10px;
  }
}

.sm-header-right {
  > div {
    width: 64px;
    height: 64px;
    // border: 1px solid #000;

    i {
      font-size: 55px;
    }
  }
}

.collapsed > .when-closed {
  display: none;
}

.not-collapsed > .when-opened {
  display: none;
}

.collapse-menu {
  width: 100%;
  background: #fff;
  z-index: 9999999;

  .sm-menu {
    text-align: center;
    width: 100%;
    max-height: calc(90vh - 95px);
    overflow: scroll;
    .search-icon{
      width: 64px;
        height: 64px;
        img{
          width: 64px;
        height: 64px;
        }
    }
    .sm-menu-item {
      // padding: 15px;
      text-align: center;

      &-title {
        font-family: "SourceHanSansCN-Regular";
        font-weight: 400;
        font-size: 32px;
        color: #333333;
        padding: 20px 0 20px 20px;
      }

      &-btn {
        width: 64px;
        height: 64px;
        // border: 1px solid red;
        margin-right: 20px;

        i {
          font-size: 35px;
        }
      }

      .collapsed  .btn-opened {
        display: none !important;
      }

      .not-collapsed  .btn-closed {
        display: none !important;
      }

      .collapse-menu-child {
        padding: 20px;
        background: #fff;
        height: 100px;
        div {
          width: 6px;
          height: 6px;
          background: #d8d8d8;
          margin-right: 15px;
        }

        span {
          font-family: "SourceHanSansCN-Regular";
          font-weight: 400;
          font-size: 24px;
          color: #666666;
          line-height: 40px;
        }
      }
    }

    .active-menu-item {
      background: #1566d4;

      .sm-menu-item-title {
        color: #fff;
      }

      .sm-menu-item-btn {
        border: none;

        i {
          color: #fff;
        }
      }
    }

    .active-menu-child-item {
      background: #1566d4 !important;

      div {
        color: #fff !important;
      }

      span {
        color: #fff !important;
      }
    }
  }
}

// 占位元素
.pla-header {
  height: 95px;
}
</style>